// ============================================================================
// INITIAL STATE - iotInitialState.js
// ============================================================================
// ./context/iot/iotInitialState.js

export default {
    logs: [],
    currentLog: null,
    studentLogs: [],
    courseLogs: [],
    labLogs: [],
    protocolLogs: [],
    devices: [],
    deviceStatus: null,
    analytics: null,
    labAnalytics: null,
    activeSessions: [],
    currentSession: null,
    pagination: {
        total: 0,
        count: 0,
        limit: 100,
        skip: 0,
        hasMore: false
    },
    // ============================================================================
    // AI GENERATION STATE (NEW)
    // ============================================================================
    aiGeneration: {
        generatedRules: null,
        generatedRubrics: null,
        completeRequirements: null,
        isGenerating: false,
        generationError: null
    },
    isLoading: false,
    error: null
}